import { Icon } from 'antd';
import React from 'react';
import * as S from './styles';
import StatusMonitoringInfo from '../../StatusMonitoringInfo';

const StatusTab = ({ large = false, jobId, users, subscribed, filters }) => {
    return (
        <S.StatusVizContainer minHeight={large ? '400px' : 'auto'}>
            <S.VizLayout gap={large ? '2rem' : '1.5rem'}>
                <StatusMonitoringInfo
                    jobId={jobId}
                    users={users}
                    subscribed={subscribed}
                    filters={filters}
                />
            </S.VizLayout>
        </S.StatusVizContainer>
    );
};

export default StatusTab;
